<script>
export default {
    name: "CancelBill",

    props: {
        showModal: Boolean,
        bill: Object,
    },

    methods: {

        cancelBillItem() {
            this.$root.loading=true;
            let url = `Theatre/CancelPatientProcedureItem`;
                url += `?ID=${this.bill.id}&UserName=${this.$root.username}`
            this.$http.post(url).then(response => {
                    this.$emit(`refresh`);
                    this.$root.loading=false;
                    this.$emit(`closeModal`);
                    window.Swal.fire({ type: `success`, text: response.data });
                }).catch(() => {this.$root.loading=false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/4 w-10/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Cancel Item</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap -m-3">
        <h5 class="font-bold text-sm">Cancel: {{ bill.service }}</h5>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button 
        class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button 
        @click.prevent="cancelBillItem"
        class="btn-primary btn-sm text-xs rounded">
            <i class="fa fa-check"></i> Cancel Item</button>
  </template>
</tail-modal>
</template>
